"use strict";
/**
* Модальное сообщение.
* @todo Шабардин П.: описать! 
* @class WebAccess.components.dialogs.MessageBox
* @since 5.0.0.4206 
* @extends WebAccess.components.dialogs.BaseDialog
* @todo Шабардин П.: свойства тоже описать
* @todo Шабардин П.: примеры
*/
(function (global) {

  var MessageBox = global.BaseDialog.extend({
    className: 'MessageBox',
    mainText: '',
    additionalText: '',
    title: '',
    //messageBoxButtons: [],
    messageBoxIcon: '',
    messageBoxIcons: { 'error': 'error-16', 'info': 'info-16', 'question': 'help-16', 'warning': 'warning-16' },
    //okText: '',
    height: 'auto',
    baseDialog: null,

    init: function (settings) {      
      this.modalWindowButtons = [];
      this._super(settings);
      if ($.isPlainObject(settings)) {
        $.extend(this, settings);
      }
    },

    /**
     * Добавить кнопку на форму диалогового окна.
     *
     * @function WebAccess.components.dialogs.MessageBox#addButton
     * @param  {string} buttonId ИД кнопки
     * @param  {string} buttonText  Надпись кнопки
     * @param  {function} buttonClick Функция для обработки действия «Нажать на кнопку»
     * @return {WebAccess.components.dialogs.MessageBox} Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    addButton: function (buttonId, buttonText, buttonClick) {
      this.modalWindowButtons.push(
        {
          id: buttonId,
          text: buttonText,
          click: !!buttonClick ? buttonClick : function () { }
        });
      return this;
    },

    /**
     * Добавить кнопку «ОК» на форму диалогового окна.
     *
     * @function WebAccess.components.dialogs.MessageBox#okButton
     * @param  {function} okCallback Функция для обработки действия «Нажать на кнопку «ОК»
     * @return {WebAccess.components.dialogs.MessageBox} Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    okButton: function (okCallback) {
      this.modalWindowButtons = [];
      this.ok = !!okCallback ? okCallback : function () { };
      this.cancel = null;
      return this;
    },

    /**
     * Добавить кнопки «Да» и «Нет» на форму диалогового окна.
     *
     * @function WebAccess.components.dialogs.MessageBox#yesNoButtons
     * @param  {function} yesCallback Функция для обработки действия «Нажать на кнопку «Да»
     * @param  {function} noCallback  Функция для обработки действия «Нажать на кнопку «Нет»
     * @return {WebAccess.components.dialogs.MessageBox} Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    yesNoButtons: function (yesCallback, noCallback) {
      this.okText = L('YES');
      this.cancelText = L('NO');
      return this.okCancelButtons(yesCallback, noCallback);
    },

    /**
     * Добавить кнопки «ОК» и «Отмена» на форму диалогового окна.
     *
     * @function WebAccess.components.dialogs.MessageBox#okCancelButtons
     * @param  {function} okCallback     Функция для обработки действия «Нажать на кнопку «ОК»
     * @param  {function} cancelCallback Функция для обработки действия «Нажать на кнопку «Отмена»
     * @return {WebAccess.components.dialogs.MessageBox} Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    okCancelButtons: function (okCallback, cancelCallback) {
      this.messageBoxButtons = [];
      this.ok = !!okCallback ? okCallback : function () { };
      this.cancel = !!cancelCallback ? cancelCallback : function () { };
      this.isShowCancelButton = true;
      this.isShowOkButton = true;
      return this;
    },

    /**
     * Показать диалоговое окно с текстом ошибки.
     *
     * @method WebAccess.components.dialogs.MessageBox#showError
     * @param  {string} mainText       Основной текст ошибки
     * @param  {string} additionalText Информационный текст, объясняющий ошибку
     * @param  {string} title          Заголовок диалогового окна
     * @param  {function} onClose        Обработчик события закрытия диалогового окна
     * @return {WebAccess.components.dialogs.MessageBox}  Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    showError: function (mainText, additionalText, title, onClose) {
      if (!title) title = L('ERROR');
      this.okText = L('CLOSE');
      this.show(mainText, additionalText, title, 'error', null, onClose);
      return this;
    },

    /**
     * Показать диалоговое окно с информацией.
     *
     * @method WebAccess.components.dialogs.MessageBox#showInfo
     * @param  {string} mainText       Основной текст сообщения
     * @param  {string} additionalText Информационный текст, объясняющий суть сообщения
     * @param  {string} title          Заголовок диалогового окна
     * @param  {function} onClose      Обработчик события закрытия диалогового окна
     * @return {WebAccess.components.dialogs.MessageBox}  Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    showInfo: function (mainText, additionalText, title, onClose) {
      if (!title) title = L('INFO');
      this.okText = L('CLOSE');
      this.show(mainText, additionalText, title, 'info', null, onClose);
      return this;
    },

    /**
     * Показать диалоговое окно с вопросом
     *
     * @method WebAccess.components.dialogs.MessageBox#showQuestion
     * @param  {string} mainText       Основной текст вопроса
     * @param  {string} additionalText Информационный текст, объясняющий суть вопроса
     * @param  {string} title          Заголовок диалогового окна
     * @param  {function} onClose      Обработчик события закрытия диалогового окна
     * @return {WebAccess.components.dialogs.MessageBox}  Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    showQuestion: function (mainText, additionalText, title, onClose) {
      if (!title) title = L('CONFIRMATION');
      this.show(mainText, additionalText, title, 'question', null, onClose);
      return this;
    },

    /**
     * Показать диалоговое окно с предупреждением.
     *
     * @method WebAccess.components.dialogs.MessageBox#showWarning
     * @param  {string} mainText       Основной текст предупреждения
     * @param  {string} additionalText Информационный текст, объясняющий суть предупреждения
     * @param  {string} title          Заголовок диалогового окна
     * @param  {function} onClose      Обработчик события закрытия диалогового окна
     * @return {WebAccess.components.dialogs.MessageBox}  Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    showWarning: function (mainText, additionalText, title, onClose) {
      if (!title) title = L('WARNING');
      this.show(mainText, additionalText, title, 'warning', null, onClose);
      return this;
    },

    /**
     * Показать диалоговое окно.
     *
     * @method WebAccess.components.dialogs.MessageBox#show
     * @param  {string} mainText        Основной текст
     * @param  {string} additionalText  Информационный текст
     * @param  {string} title           Заголовок диалогового окна
     * @param  {string} icon            Иконка диалогового окна, например, иконка сообщения об ошибке. Возможные значения: error, info, question, warning
     * @param  {string} defaultButtonId ИД кнопки, которая будет выделена на форме как действие по умолчанию. Имеет смысл, когда кнопки были добавлены через метод addButton
     * @param  {function} onClose       Обработчик события закрытия диалогового окна
     * @return {WebAccess.components.dialogs.MessageBox} Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    show: function (mainText, additionalText, title, icon, defaultButtonId, onClose) {
      var me = this;
      if (mainText === null) return me;
      me.setMainText(mainText);
      me.setAdditionalText(additionalText);
      if (!!title) me.title = title;
      if (!!icon) me.messageBoxIcon = icon;
      me._setDefaultButton(defaultButtonId);
      if (!!onClose) me.onClose = onClose;
      me.setHtml(me._getHtml());
      //var dialog = new WA.CMP.dialogs.BaseDialog(this._createSettingsObject());
      //dialog.height = this.height;
      //dialog.width = this.width;
      //this.baseDialog = dialog;
      me.onOpen = function () {
        me._jDialog.parents('.ui-dialog:first').addClass((!!icon ? icon : '') + '-mbox');
      };
      me._super();
      //dialog.show();
      return me;
    },

    /**
     * Добавляет основной текст на форму диалогового окна.
     *
     * @method WebAccess.components.dialogs.MessageBox#setMainText
     * @param  {string} mainText Основной текст
     * @return {WebAccess.components.dialogs.MessageBox} Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    setMainText: function (mainText) {
      if (!!mainText) {
        var splitterIndex = mainText.indexOf('^');
        if (splitterIndex != -1) {
          //var text = mainText.split('^');
          //mainText = text[0];
          this.setAdditionalText(mainText.substring(splitterIndex + 1, mainText.length).fromISBuilderToNormal());
          mainText = mainText.substring(0, splitterIndex);
        }
        this.mainText = mainText;

        if (this.isOpened() && this._jDialog) {
          this._jDialog.find('.upper-area-text').html(mainText);
        }
      }
      return this;
    },

    /**
     * Добавляет информационный текст на форму диалогового окна.
     *
     * @method WebAccess.components.dialogs.MessageBox#setAdditionalText
     * @param  {string} additionalText Информационный текст
     * @return {WebAccess.components.dialogs.MessageBox} Oбъект класса MessageBox.
     * @since 5.0.0.4206
     */
    setAdditionalText: function (additionalText) {
      if (!!additionalText || typeof additionalText == 'string') {
        this.additionalText = ('' + additionalText);
        if (this.isOpened() && this._jDialog) {
          this._jDialog.find('.lower-area').html(additionalText);
        }
      }
      return this;
    },

    /**
     * Устанавливает кнопку по умолчанию в диалоге. Имеет действие только если кнопки добавлялись через метод addButton
     * @private
     * @param  {string} buttonId ид кнопки по умолчанию
     * @since 5.0.0.4206
     */
    _setDefaultButton: function (buttonId) {
      if (!!buttonId && !!this.modalWindowButtons && this.modalWindowButtons.length) {
        for (var btn in this.modalWindowButtons) {
          if (this.modalWindowButtons[btn].id == buttonId) {
            this.modalWindowButtons[btn]['class'] = 'primary';
            break;
          }
        }
      }
      return this;
    },

    /**
     * создает объект с настройками для отображения окна
     * @private
     * @since 5.0.0.4206
     */
    _createSettingsObject: function () {
      var showOkButton = this.messageBoxButtons.length === 0 || !!this.ok;
      var showCancelButton = !!this.cancel;
      var settings = {
        html: this._getHtml(),
        title: this.title,
        modalWindowButtons: this.messageBoxButtons,
        isShowOkButton: showOkButton,
        isShowCancelButton: showCancelButton
      };
      if (!!this.onClose) settings['onClose'] = this.onClose;
      if (!!this.ok) settings['ok'] = this.ok;
      if (!!this.cancel) settings['cancel'] = this.cancel;
      if (!!this.okText) settings['okText'] = this.okText;
      if (!!this.cancelText) settings['cancelText'] = this.cancelText;
      return settings;
    },

    /**
     * возвращает html-разметку для окна
     * @private
     * @since 5.0.0.4206
     */
    _getHtml: function () {
      var icon = !!this.messageBoxIcon ? '<svg class="ui-dialog__icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#' + this.messageBoxIcons[this.messageBoxIcon] + '"></use></svg>' : '';
      var mainTextHtml = '<div class="upper-area"><div class="upper-area-icon"><p>' + icon + '</p></div><div class="upper-area-text">' + this.mainText + '</div></div>';
      var additionalTextHtml = '<div class="lower-area">' + this.additionalText + '</div>';
      var html = '<div class="main-area">' + mainTextHtml + additionalTextHtml + '</div>';
      return html;
    }

  });

  global.MessageBox = MessageBox;
})(window.WebAccess.components.dialogs);